import api from "@/lib/api";

export type PostCloudContractRequest = {
  setupIntentId: string;
  planCode: string;
  currencyCode: string;
  paymentType: string;
};

export type PostCloudContractResponse = {
  status: string;
  contractNumber: string;
};

export default {
  postCloudContract(data: PostCloudContractRequest) {
    return api<PostCloudContractRequest, PostCloudContractResponse>({
      endpoint: "cloud/web-api/contract",
      method: "POST",
      body: data
    });
  }
};
